import type { CmsData } from '@packages/cms-components/interfaces/webapp_json';
import useSWR from 'swr';
import { bucketFetcher, getEndpoint } from '@packages/cms-components';
import { useRouter } from 'next/router';
import config from '@packages/config';

export const useFooterData = () => {
  const { locale: language, defaultLocale: defaultLanguage } = useRouter();
  const finalLanguage = language || defaultLanguage || 'de';
  const footerCmsCacheKey = `footer-${finalLanguage}`;
  const { footer } = config;
  const footerCmsEndpoint = getEndpoint(footer.apiEndpoints.bucket, 'footer', finalLanguage);
  const { data } = useSWR<CmsData>(footerCmsCacheKey, bucketFetcher<CmsData>(footerCmsEndpoint), {
    // prevent fetching newer data (https://swr.vercel.app/docs/revalidation#disable-automatic-revalidations)
    // but revalitate if stale to make language switch work
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateOnMount: false,
  });
  return data;
};
